
import { defineComponent, ref, onMounted } from 'vue'
import { EyeOutlined } from '@ant-design/icons-vue'

export default defineComponent({
    props: {
        placeholder: {
            type: String,
            required: true,
            default: ''
        },
        modelValue: {
            type: String,
            required: true,
            default: ''
        }
    },
    components: {
        EyeOutlined
    },
    setup(props, ctx) {
        const pwdtype = ref('password')
        const iptChange = (e: any) => {
            ctx.emit('update:modelValue', e.target.value)
        }
        const handleChangePwdtype = (type: string) => {
            pwdtype.value = type
        }
        onMounted(() => {
        })
        return {
            pwdtype,
            handleChangePwdtype,
            iptChange,
        }
    }
})
